<template>
  <div class="testing">
    <div class="paper">
      <h2 class="paper_title">{{ $route.query.chapterTitle }}</h2>
      <!-- <div class="allow-answer">
        允许学生查看答案：<el-switch
          v-model="lookTestAnswer"
          @change="handleChange"
        >
        </el-switch>
      </div> -->
      <div class="main">
        <div class="single" v-show="radio.length > 0">
          <h3 class="type_title">
            单选题
            <span style="margin-left: 5px">{{ sum(radio) }}分</span>
          </h3>
          <div
            class="one"
            v-for="(single, idx) in radio"
            :key="single.questionId"
          >
            <p class="stem">
              <span>{{ idx + 1 }}.</span>
              {{ single.question }}
            </p>
            <div class="options">
              <p
                class="option"
                v-for="option in single.optionList"
                :key="option.optionId"
              >
                <span>{{ option.tag }}.</span>
                {{ option.option }}
              </p>
            </div>
            <p class="anwser">
              <span>正确答案：</span>
              {{ single.answerList[0] }}
            </p>
          </div>
        </div>

        <div class="multiple" v-show="checkbox.length > 0">
          <h3 class="type_title">
            多选题
            <span style="margin-left: 5px">{{ sum(checkbox) }}分</span>
          </h3>
          <div
            class="one"
            v-for="(multiple, idx) in checkbox"
            :key="multiple.questionId"
          >
            <p class="stem">
              <span>{{ idx + 1 }}.</span>
              {{ multiple.question }}
            </p>
            <div class="options">
              <p
                class="option"
                v-for="option in multiple.optionList"
                :key="option.optionId"
              >
                <span>{{ option.tag }}.</span>
                {{ option.option }}
              </p>
            </div>
            <p class="anwser">
              <span>正确答案：</span>
              {{ multiple.answerList.join("") }}
            </p>
          </div>
        </div>

        <div class="judge" v-show="boolean.length > 0">
          <h3 class="type_title">
            判断题
            <span style="margin-left: 5px">{{ sum(boolean) }}分</span>
          </h3>
          <div
            class="one"
            v-for="(judge, idx) in boolean"
            :key="judge.questionId"
          >
            <p class="stem">
              <span>{{ idx + 1 }}.</span>
              {{ judge.question }}
            </p>
            <div class="options">
              <p class="option">
                <span>A.</span>
                对
              </p>
              <p class="option">
                <span>B.</span>
                错
              </p>
            </div>
            <p class="anwser">
              <span>正确答案：</span>
              {{ judge.answerList[0] }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { chapterTest } from "@/api/chapter";
export default {
  props: {
    info: Object,
  },
  data() {
    return {
      questionList: [],
      radio: [],
      checkbox: [],
      boolean: [],
      classChapterId: null,
    };
  },
  activated() {
    if (this.classChapterId != this.$route.query.classChapterId) this.getTest();
  },
  deactivated() {
    this.classChapterId = this.$route.query.classChapterId;
  },
  computed: {
    lookTestAnswer: {
      get() {
        return this.info.lookTestAnswer == "OPEN" ? true : false;
      },
      set() {},
    },
  },
  methods: {
    // 题目列表
    getTest() {
      this.$loading.show();
      chapterTest(this.$route.query.classChapterId).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.questionList = res.data;
          this.classify(res.data);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 题目分类
    classify(arr) {
      this.radio = [];
      this.checkbox = [];
      this.boolean = [];
      arr.forEach((item) => {
        switch (item.type) {
          case "RADIO":
            if (this.isInArray(this.radio, item)) return;
            this.radio.push(item);
            break;
          case "CHECKBOX":
            if (this.isInArray(this.checkbox, item)) return;
            this.checkbox.push(item);
            break;
          case "BOOLEAN":
            if (this.isInArray(this.boolean, item)) return;
            this.boolean.push(item);
            break;
        }
      });
    },
    // 是否存在
    isInArray(arr, item) {
      return arr.some((e) => e.questionId === item.questionId);
    },
    // 计算总分
    sum(arr) {
      return Number(
        arr
          .reduce(function (prev, curr) {
            return curr.score + prev;
          }, 0)
          .toFixed(2)
      );
    },
    handleChange(status) {
      this.$emit("editLook", status);
    },
  },
};
</script>

<style lang="less" scoped>
.testing {
  height: 100%;
  .paper {
    position: relative;
    margin: 15px auto;
    padding: 40px;
    width: 915px;
    height: 95%;
    overflow: auto;
    // background-image: url("../../assets/images/paper_bg.png");
    // background-size: cover;
    // background-repeat: no-repeat;

    &::-webkit-scrollbar {
      width: 4px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      background-color: #c8c8c8;
    }

    .paper_title {
      margin-bottom: 40px;
      text-align: center;
    }

    .allow-answer {
      position: absolute;
      top: 45px;
      right: 30px;
      line-height: 1;
    }
    .type_title {
      margin-top: 20px;
      padding-left: 43px;
      font-size: 20px;
    }

    .one {
      padding: 10px 0 20px 43px;
      font-size: 18px;
      border-bottom: solid 1px #ddd;

      .options {
        .option {
          margin: 10px 0;
        }
      }

      .anwser {
        color: #ff0000;
      }
    }
  }
}
</style>